/**
 * Иногда api отвечает редиректом (302) на страницу входа в админку,
 * когда пользователь не авторизован.
 *
 * fetch следует за редиректом сам, поэтому статус 302 в ответе не видно —
 * итоговый ответ будет выглядеть как обычный 200 с html страницы входа.
 * Здесь такой ответ и распознаётся.
 */
export function isRedirectToLoginPage(response: Response): boolean {
  // response.redirected === true, если fetch выполнил переход по редиректу
  if (!response.redirected) {
    return false
  }

  // Страница входа отдаёт html вместо json/файла
  const contentType = (response.headers.get('content-type') ?? '').toLowerCase()
  if (contentType.includes('text/html')) {
    return true
  }

  // Или редирект ведёт на url входа/админки
  const url = response.url.toLowerCase()
  return (
    url.includes('login') || url.includes('signin') || url.includes('admin')
  )
}
